import { ChangeEvent } from "@mcleod/components";
import { LocationByTypeProps, LocationByTypeUtil } from "@mcleod/dispatch";
import { AutogenLayoutLoadTenderExpressProfile } from "./autogen/AutogenLayoutLoadTenderExpressProfile";

const LOCATION_BY_TYPE_PROPS: LocationByTypeProps = {
    stateType: 'S',
    zoneType: 'Z',
    locationType: 'L',
    useDefault: true
}

export class LoadTenderExpressProfile extends AutogenLayoutLoadTenderExpressProfile {
    override async onLoad() {
        LocationByTypeUtil.setupLocationTypeChangeListener(this.textboxOrigType, this.textboxOrigZones, LOCATION_BY_TYPE_PROPS);
        LocationByTypeUtil.setupLocationTypeChangeListener(this.textboxDestType, this.textboxDestZones, LOCATION_BY_TYPE_PROPS);
    }

    textboxDaysPreviousOnChange(event: ChangeEvent) {
        this.displayDates();
    }
    /** Method to display the current date and the date offset by 400 days */
    displayDates() {
        const currentDate = new Date();
        const offsetDate = new Date();
        const daysPrevious = parseInt(this.textboxDaysPrevious.text, 10);
        offsetDate.setDate(currentDate.getDate() - daysPrevious);

        this.textboxDateRange.text = this.formatDate(offsetDate) + ' - ' + this.formatDate(currentDate);
    }
    formatDate(date: Date): string {
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }
}
